import {CommonErrorModal} from "@app/components/modals/CommonErrorModal"
import { BlogpayLoginForm } from "@app/components/signup/Blogpay";
import { PlatformSelectForm } from "@app/components/signup/Step1";
import { AccountForm } from "@app/components/signup/Step2";
import { PlatformInfoForm } from "@app/components/signup/Step3";
import { PaymentMethodForm } from "@app/components/signup/Step4";
import { PriceAgreementForm } from "@app/components/signup/Step5";
import { RegistrationComplete } from "@app/components/signup/Step6";
import {Path} from "@app/route_path"
import {useModal} from "@shortsworks/ui"
import { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Steps } from "@app/pages/auth/Signup/type";

export const Signup = () => {
  const { showModal } = useModal();
  const { path } = useParams();
  const steps: string[] = Object.values(Steps);

  const navigate = useNavigate();
  const location = useLocation();

  // step이 벗어나는 경우 체크
  useEffect(() => {
    if (!path || !steps.includes(path)) {
      navigate([Path.SIGNUP, Steps.STEP1].join("/"), {
        state: {
          [Steps.PATH]: Steps.STEP1
        }
      });
      return;
    }

    if(path !== location.state?.path) {
      showModal(CommonErrorModal, {title: "회원가입을 순서대로 진행해주세요."});
      navigate([Path.SIGNUP, Steps.STEP1].join("/"), {
        state: {
          [Steps.PATH]: Steps.STEP1
        }
      });
    }
  }, []);

  return (
    <div className="flex items-center justify-center py-12">
      <div className="flex flex-col mx-auto grid w-[350px] gap-6">
        {path === Steps.STEP1 && <PlatformSelectForm />}
        {path === Steps.STEP2 && <AccountForm />}
        {path === Steps.STEP3 && <PlatformInfoForm />}
        {path === Steps.STEP4 && <PaymentMethodForm />}
        {path === Steps.STEP5 && <PriceAgreementForm />}
        {path === Steps.STEP6 && <RegistrationComplete />}
        {path === Steps.STEP_BLOGPAY && <BlogpayLoginForm />}
      </div>
    </div>
  );
};
